import React, { useEffect, useState } from 'react'

import Topbar from './Topbar'
import Sidebar_component from './Sidebar_component'
import { useNavigate } from 'react-router-dom';

export default function Invoicelist() {
    const navigate = useNavigate();
    const [projectList, setProjectList] = useState([]);
    const [selectedProject, setSelectedProject] = useState('');
    const [invoiceList, setInvoiceList] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        loadProjects();
    }, []);

    async function loadProjects() {
        try {
            let com_id =
                localStorage.getItem('mem_company_id');
            const response = await fetch(
                'getProjectsForBilling.php',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        company_id: com_id
                    })
                }
            );
            const data = await response.json();
            setProjectList(data);
        } catch (error) {
            console.log(error);
        }
    }
    function backtobillable() {
        navigate('/bilable_hours');
    }

    async function generateinvoicelist(e) {
        try {
            const proid =
                e.target.value;
            setSelectedProject(proid);
            const response = await fetch(
                'getInvoiceList.php', {
                method: 'POST',
                headers: {
                    'Content-Type':
                        'application/json'
                },
                body: JSON.stringify({
                    project_id: proid
                })
            }
            );
            const data =
                await response.json();
            setInvoiceList(data);
        } catch (error) {
            console.log(error);
        }
    }

    function downloadInvoice(pdf) {
        window.open(
            pdf,
            '_blank'
        );
    }

    async function cancelInvoice(item) {
        const confirmCancel = window.confirm('Cancel this invoice?');
        if (!confirmCancel) {
            return;
        }
        try {
            const response = await fetch(
                'cancelInvoice.php', {
                method: 'POST',
                headers: {
                    'Content-Type':
                        'application/json'
                },
                body: JSON.stringify({
                    invoice_id: item.id,
                    client_email: item.cl_email,
                    invoice_number: item.invoice_number,
                    project_name: item.project_name,
                    company_email: localStorage.getItem('useremail')
                })
            }
            );
            const data =
                await response.json();

            if (
                data.status === 'success'
            ) {

                alert(
                    'Invoice cancelled'
                );

                generateinvoicelist({
                    target: {
                        value: selectedProject
                    }
                });

            }

        } catch (error) {

            console.log(error);

        }

    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

   

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>
                        Invoice List
                    </h2>
                    <button className='allinvoice' onClick={backtobillable}>Back</button>
                    <p className='fullwidth pull_left pb-30'>
                        You can see details of any invoice or can download, by selecting a project from the dropdown.
                    </p>
                </div>
                <div className='fullwidth'>
                    <p className='pt-15 pb-30 pull_left fullwidth'>Select sa project from the dropdown below and view all previous invoice details. You can downlaod any invoice by click on dopwnlaod button </p>
                    <div className='pro_dropdown'>
                        <select onChange={generateinvoicelist}>
                            <option value=''>
                                Select Project
                            </option>
                            {
                                projectList.map((item, index) => (
                                    <option
                                        key={index}
                                        value={item.id}
                                    >
                                        {item.pr_name}
                                    </option>
                                ))
                            }

                        </select>
                    </div>
                    <div className='vl_listing_area'>



                        {
                            invoiceList.length > 0 ? (
                                invoiceList.map((item, index) => (
                                    <div className='resource_card_one_third' key={index}
                                        style={{ background: item.invoice_sent === 'cancel' ? '#ffe5e5' : 'transparent' }}>
                                        <div className='resource_inner'>
                                            <div className='fullwidth pull_left pt-21'>
                                                <h3>{item.project_name}</h3>
                                                <div className='fullwidth pull_left pb-10'>
                                                    <span>{item.invoice_sent === 'cancel' ? 'Cancelled' : 'Active'}</span>
                                                </div>
                                            </div>
                                            <div className='divider'>&nbsp;</div>
                                            <div className='vl_dsh_one_half'>
                                                <p>Ampunt: {item.bill_amount}</p>
                                            </div>
                                            <div className='vl_dsh_one_half'>
                                                <p>Hours: {item.hours}h</p>
                                            </div>
                                            <div className='vl_dsh_one_half'>
                                                <p>INV. No: {item.invoice_number}</p>
                                            </div>
                                            <div className='vl_dsh_one_half'>
                                                <p>{item.dt_calculation}</p>
                                            </div>
                                            <div className='list_buttonholder'>
                                                <button className='shortbtn' title='Download Invoice' onClick={() => downloadInvoice(item.invoice_pdf)}><i className="ri-download-2-line"></i></button>
                                                {
                                                    item.invoice_sent !== 'cancel' && (
                                                        <button className='shortbtn' title='Cancel Invoice' onClick={() =>
                                                            cancelInvoice(item)}>
                                                            <i className="ri-close-circle-line"></i>
                                                        </button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                ))) : (



                                <div className='vl_dsh_one_full text_center'>

                                    No invoice found

                                </div>



                            )
                        }


                    </div>
                </div>
            </div>
        </div>
    )
}
